/*export default {
    dev : 'http://14.18.111.155:8686/CulturalCloud',
    address : 'http://14.18.111.155:8686'
}*/

/*export default {
    dev : 'https://api.stwhyun.com',
    address : 'https://api.stwhyun.com'
}

/*export default {
    dev : 'https://hsadmin.52hdc.com',
    address : 'https://hsadmin.52hdc.com'
}*/


// export default {
//     // dev : 'https://testapi.stwhyun.com',
//     // address : 'https://testapi.stwhyun.com'
//     dev : 'http://localhost:9090',
//     address : 'http://localhost:9090'
// }


export default {
    dev : 'https://api.stwhyun.com',
    address : 'https://api.stwhyun.com'
}

/*export default {
    dev : 'http://14.18.111.74:8686/CulturalCloud',
    address : 'http://14.18.111.74:8686'
}*/

// export default {
//     dev : 'http://a039ujztts.51http.tech/CulturalCloud',
//     address : 'http://a039ujztts.51http.tech'
// }